/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Plan_Feat2Inputs */

const en_builder_plan_feat2 = /** @type {(inputs: Builder_Plan_Feat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 live apps, hosted while subscribed`)
};

const id_builder_plan_feat2 = /** @type {(inputs: Builder_Plan_Feat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 aplikasi online, hosting selama berlangganan`)
};

/**
* | output |
* | --- |
* | "2 live apps, hosted while subscribed" |
*
* @param {Builder_Plan_Feat2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const builder_plan_feat2 = /** @type {((inputs?: Builder_Plan_Feat2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Plan_Feat2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builder_plan_feat2(inputs)
	return en_builder_plan_feat2(inputs)
});